import { render } from "./TheTruongMamNon_LopHoc.vue?vue&type=template&id=3e7e7a78"
import script from "./TheTruongMamNon_LopHoc.vue?vue&type=script&lang=js"
export * from "./TheTruongMamNon_LopHoc.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__